export default {
  root: {
    display: 'flex'
  },
  tooltip: { cursor: 'default' },
  infoIcon: {
    marginLeft: '5px'
  }
};
